/* unplugin-vue-components disabled */import { render } from "./AppFooter.vue?vue&type=template&id=344eadd1&scoped=true"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=344eadd1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344eadd1"]])

export default __exports__